import { ReactElement } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { RadioButton } from '~/components';
import { EditClientFormValues } from '../Form/types';

export function GroupRadioInput({
  disabled,
}: Readonly<{
  disabled: boolean
}>): ReactElement {
  const { control, setValue } = useFormContext<EditClientFormValues>();

  const clientTypeWatch = useWatch({
    control,
    name: 'clientType',
  });

  function onClickRadio(value: string): void {
    setValue('clientType', value);
  }

  return (
    <div style={{ display: 'flex', gap: 16 }}>
      <RadioButton
        label="Cliente"
        checked={clientTypeWatch === 'cliente'}
        onClick={() => onClickRadio('cliente')}
        variant="new-radio"
        disabled={disabled}
      />
      <RadioButton
        label="Mantenedor"
        checked={clientTypeWatch === 'mantenedor'}
        onClick={() => onClickRadio('mantenedor')}
        variant="new-radio"
        disabled={disabled}
      />
      <RadioButton
        label="Fabricante"
        checked={clientTypeWatch === 'fabricante'}
        onClick={() => onClickRadio('fabricante')}
        variant="new-radio"
        disabled={disabled}
      />
    </div>
  );
}
